import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import './panel.css';

var descriptor = {};
var origDescriptor = null;

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

var tab;

function noJobs(){
	// $('.alert').remove();
	// var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No tasks found');
	// $('#topbuttons').prepend(empty);
	$('#documentlist').hide();
}

var roleLabels = {'nlp_an':'Annotator', 'nlp_qc':'Quality Control'}

function NlpJobs(prop) {
	window.getParams();
	var jobs = [];
	var hasFullList = false;


	function displayJobs( role )
	{
		var email = window.GlobalVars.userEmail;
		var hemail = email.replace(/\./g,'*');

		function formatEmail( e ) {
			if( !e ) return '';
			var elist = isstring(e) ? e.split(',') : e;
			// return elist.map( em => frm.smallerText(em) ).join('')
			return frm.aLast(elist.map( em => frm.smallerText(em) ))
		}

		// Group bulk tasks
		var bulks = {};
		for( var j of jobs ) if( j.projectType == 'Bulk Image Classification' ) {
			if( !bulks[j.project] ) bulks[j.project] = {
				count: 0, 
				projectName: j.projectName,
				projectType: j.projectType,
				type: j.type,
				role: j.role,
				state: j.state,
				annotationCount: 0
			};
			// console.log( 'BULKKKKKKKKKKKKKKKKKKKKKK', j.fileId, j.state)
			bulks[j.project].count++;
			bulks[j.project].annotationCount += j.annotationCount;
			bulks[j.project].modified = j.modified;
		}
		console.log( 'BULKS', bulks )
		for( var b in bulks ) {
			var bd = bulks[b];
			var brec = {
				"project": b,
				"fileIds": jobs.filter( j => j.project == b ).map( v => v.fileId),
				"name": bd.count+" items",
				"type": "image/tiff",
				"projectType": bd.projectType,
				"projectName": bd.projectName,
				"preview": "",
				"company": "6230d38d2eeb15e45bdb64af",
				"state": bd.state,
				"active": true,
				"modified": bd.modified,
				"created": bd.created,
				"role": bd.role,
				"annotationCount": bd.annotationCount,
			}
			jobs = jobs.filter( j => j.project != b );
			jobs.unshift( brec )
		}

		jobs.forEach( j => {
			var an = ( j.tmpAnnotations && j.tmpAnnotations[hemail] ) || null;
			if( an ) j.modified = Math.floor(an.lastUpdate/1000);
			if( !an && j.taskAnnotations ) an = (j.taskAnnotations.find( t => t.email == email) || {}).annotations;
			if( !an ) an = {};
			var nan = 0;
			nan += (an.tags && an.tags.length) || 0;
			nan += (an.links && an.links.length) || 0;
			nan += (an.boxes && an.boxes.length) || 0;
			if( an.classifications )
			{
				for( var c in an.classifications ) nan += an.classifications[c].length;
			}
			j.n_annotations = nan;
			j.n_annotations = j.annotationCount;
			j.stateLabel = '<span class="state_'+j.state+'">' + window.stateLabels[j.state] + '</span>';
			// j.prev = j.preview == 'Image file' ? 'adlthumb:'+j.fileId : j.preview;
			j.userEmail = formatEmail( j.userEmail );
			j.qcEmail = formatEmail( j.qcEmail );
			j.prev = j.preview;
			j.thumb = [j.fileId,j.thumb,j.type];
		})
		console.log( 'JOOOOOOBS', jobs, hemail )
		// return;
		var desc = {
			title: 'Current Tasks',
			columns: {
				// project: 'Project',
				projectName: 'Project',
				thumb: 'Thumb.',
				name: 'File Name',
				prev: 'Preview',
				n_annotations: 'Annotations',
				userEmail: 'Annotator',
				qcEmail: 'Reviewer',
				modified: 'Updated',
				stateLabel: 'State',
			},
			filter: true,
			search: true,
			sort: true,
			initialSort: 'modified',
			initialSortDir: -1,
			pageSize: 10,
			noFilter: {  modified: 1, n_annotations: 1 },
			noSearch: null,
			noSort: null,
			centerCol: ['thumb','annotations','state','modified'],
			format: tabler.formatString,
			forceType: {modified:1},
			formatCol:{
				thumb: frm.formatThumb,
				modified: tabler.formatTimeAgoSec,
				state: tabler.formatState,
				prev: frm.formatPreview,
				annotations: frm.smallerText,
			}
			// clickCol: ['stateLabel','source'],
		}
		if( !hasFullList ) {
			delete desc.columns.userEmail;
			delete desc.columns.qcEmail;
		}
		tab = tabler.table($('#documentlist'), desc, 'jobs' );
		jobs.forEach( a => {
			tab.addRow(a, function( col, row ){
				console.log( 'tabler click', row, tab )
				if( row.projectType == 'Bulk Image Classification' ) {
					window.GlobalVars.bulkObject = row;
					var page = 'bulkAnnotations';
					window.saveSession( function(){
						window.goPage(page, window.getParams());
					})
					return;
				}
				window.GlobalVars.PDFFileId = row.fileId;
				window.GlobalVars.PDFRole = row.role;

				var params = window.projectParams(
					{
						id:row.project,
						type:row.projectType,
						name:row.projectName,
						company:row.company,
						role:row.role || null,
						active: true,
					}
				)
				// alert( JSON.stringify(params) )
				params.fileId = row.fileId;
				frm.makeTaskList( tab.baseRows, row.fileId, row.project, () => {
					var projectType = row.projectType;
					var page = 'nlpAnnotations';
					if( projectType == 'Media Transcription' ) page = 'transcription';
					if( projectType == 'AmEx Audio Templete' ) page = 'transcription2';
					if( projectType == 'Code Switching' ) page = 'transcription3';
					else if( projectType == 'Pose Estimation' ) page = 'poseestimation';
					else if( projectType == 'Segmentation' ) page = 'segmentation';
					else if( projectType == 'Key Point' ) page = 'keypoint';
					// console.log( 'row', row )
					window.goPage(page, params );
				} );
			})
		});
		tab.onDraw( frm.loadThumbnails );
		tab.draw();
		if (window.GlobalVars.taskList && window.GlobalVars.taskList.next) {
			var idx = tab.baseRows.findIndex(r => r.data.fileId == window.GlobalVars.taskList.next);
			delete window.GlobalVars.taskList.next;
			if( idx < 0 ) idx = 0;

			if( tab.baseRows[idx] )
			{
				var params = window.getParams();
				window.GlobalVars.PDFFileId = tab.baseRows[idx].data.fileId;
				window.GlobalVars.PDFRole = tab.baseRows[idx].data.role;
				params.fileId = window.GlobalVars.PDFFileId;
				params.role = window.GlobalVars.PDFRole;
				frm.makeTaskList( tab.baseRows, tab.baseRows[idx].data.fileId, tab.baseRows[idx].data.project )
				window.saveSession( function(){
					var projectType = tab.baseRows[idx].data.projectType;
					var page = 'nlpAnnotations';
					if( projectType == 'Media Transcription' ) page = 'transcription';
					if( projectType == 'AmEx Audio Templete' ) page = 'transcription2';
					if( projectType == 'Code Switching' ) page = 'transcription3';
					else if( projectType == 'Pose Estimation' ) page = 'poseestimation';
					else if( projectType == 'Segmentation' ) page = 'segmentation';
					else if( projectType == 'Key Point' ) page = 'keypoint';
					window.goPage(page, params );
				});

			}
			else $(document.body).show();
		}
	}



	function summary( jobs )
	{
		return;
		if( jobs ) console.log( 'SUMMARY', clone(jobs))
		var total = 0;
		var stats = {}
		var out = [];
		for( var p in jobs )
		{
			var proj = jobs[p];
			for( var s in proj )
			{
				total += proj[s];
				stats[s] = (stats[s] || 0) + proj[s];
				console.log( 'summary', p, s, 'v', proj[s], 'total', total, clone(stats) )
			}
		}
		out.push( total + ' total tasks' );
		for( var s in stats )
		{
			out.push( '<span class="state_'+s+'">'+stats[s]+' '+ window.stateLabels[s]+'</span>')
		}
		$('#summary').html( '<p>' + out.join('</p><p>' ) + '</p>' );
	}

    function initProject()
    {
		$('#topbuttons').html('');
		if( 0 && window.hasPriv( 'admin', 'c_admin') )
		{
			var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 btn btn-primary">Back to Projects</Button>')
			projBut.on('click', () => {
				window.GlobalVars.PDFProjectId = null;
				window.GlobalVars.PDFFileId = null;
				window.saveSession();
				window.goPage('nlpProjectBrowse', window.getParams());
			})
			$('#topbuttons').append(projBut);
		}
		// $('#pageTitle').text( '' );
		frm.loading('Loading Tasks');
		window.post('find_jobs',{email:window.GlobalVars.userEmail,userId:window.GlobalVars.userId}, function( res ){
			jobs = res.data.records;
			hasFullList = res.data.hasFullList || false;
			if( !jobs.length ) noJobs();
			console.log( 'JOBS', clone(res) )
			frm.loadingOut();
			displayJobs();
			summary(res.data.jobs);
		});
    }
    useEffect( function(a){
		if (window.GlobalVars.taskList && window.GlobalVars.taskList.next) $(document.body).hide();
        initProject();
    });

    return (
        <div fluid="md p-0" className="maincontent">
        <div className="row">
        <Col className="mt-3">
		<div id="topbuttons"></div>
		<Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
		</Table>
		<div id="summary"></div>
        </Col>
        </div>
        </div>

    )
}

export default NlpJobs


